import React, { memo } from 'react';
import { AddressHeaderWrapper, AddressText } from './styled';

const AddressHeader = memo(({ showBorder, title, content }) => {
  return (
    <AddressHeaderWrapper showBorder={showBorder}>
      <AddressText isTitle>{title}</AddressText>
      <AddressText>{content}</AddressText>
    </AddressHeaderWrapper>
  );
});

export default AddressHeader;
